import React from "react";
import { withGlobal } from "reactn";

import { getLoginLink } from "utils/urls";

import RouterLink from "components/RouterLink";

const AlreadyHaveAnAccount = ({ missionName }) => {
  return (
    <div className="ln-u-text-align-center">
      <span>Already have a {missionName} account?</span>
      <div className="ln-u-margin-top*1/2">
        <RouterLink
          link={getLoginLink()}
          className="ln-c-link ln-c-link--bare ln-c-link--cta"
        >
          Log in
        </RouterLink>
      </div>
    </div>
  );
};

export default withGlobal((global) => ({
  missionName: global.readable_mission_name,
}))(AlreadyHaveAnAccount);
